<template>
    <main class="app-container">
        <section class="new-project">
            <div class="new-project__breadcrumbs">
                <router-link :to="{name: 'projects-list'}">{{$t('project_details.breadcrumbs.project')}}</router-link>
                <span><svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.8 3.99976L1.19979 7.59998L0 6.39934L2.40042 3.99976L0 1.60019L1.19979 0.399551L4.8 3.99976Z" fill="#94A2A6"/>
                    </svg>
                </span>
                <a href="">{{projectInfo.name}}</a>
                <span><svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.8 3.99976L1.19979 7.59998L0 6.39934L2.40042 3.99976L0 1.60019L1.19979 0.399551L4.8 3.99976Z" fill="#94A2A6"/>
                    </svg>
                </span>
                <a v-if="activeContentTab === 'styleQuiz'" href="">{{$t('project_details.tab_menu.style_quiz')}}</a>
                <a v-if="activeContentTab === 'proposal'" href="">{{$t('project_details.tab_menu.ewoods_proposal')}}</a>
                <a v-if="activeContentTab === 'shoppingList'" href="">{{$t('project_details.tab_menu.shopping_list')}}</a>
                <a v-if="activeContentTab === 'order'" href="">{{$t('project_details.tab_menu.orders')}}</a>
            </div>
            <div class="new-project__top">
                <h1>{{projectInfo.name}} <span v-for="client in clients">/ {{ [client?.firstName, client?.lastName].join(' ') }}</span> </h1>
                <router-link v-if="projectInfo.id && (auth.user.role === Role.Admin)" :to="{name: 'admin.project-settings',params: {id: projectInfo.id}}">
                    <img src="@/assets/icons/settings.svg" alt="" />{{$t('project_details.settings_title')}}
                </router-link>
                <router-link v-else-if="projectInfo.id && (projectInfo.myRoleInProject === Role.Architect)" :to="{name: 'project-settings',params: {id: projectInfo.id}}">
                    <img src="@/assets/icons/settings.svg" alt="" />{{$t('project_details.settings_title')}}
                </router-link>
            </div>
            <div class="new-project__tabs">
            <tabs-menu
                @change-tab="changeTab"
                :active-tab="activeContentTab"
            />
            </div>

            <div class="proposals__wrapper" v-if="projectInfo">
            <proposal v-if="activeContentTab == 'proposal'"
                        :projectInfo="projectInfo"
                        @update:currentSlider="currentSlider = $event"
            />
            <style-quiz v-if="activeContentTab == 'styleQuiz'"
                        :projectInfo="projectInfo"
            />
            <shopping-list v-if="activeContentTab == 'shoppingList'" :projectInfo="projectInfo" />
            <orders v-if="activeContentTab == 'order'" />
            </div>

            <!-- <comments
                :currentSlider="currentSlider"
                :activeContentTab="activeContentTab"
                :isProposal="projectInfo?.designProposals?.length"
            /> -->
        </section>
    </main>
</template>

<script>
import Proposal from "@/components/projectDetails/tabs/Proposal";
import ShoppingList from "@/components/projectDetails/tabs/ShoppingList";
import TabsMenu from "@/components/projectDetails/tabs/TabsMenu";
import {inject, onMounted, ref, onBeforeUnmount, computed} from "vue";
import StyleQuiz from "@/components/projectDetails/tabs/StyleQuiz";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import router from "@/router";
import authHelper from "@/helpsers/auth.helper";
import {useAuthStore} from "@/stores/auth.store";
import {Role} from "@/helpsers/role.helper";

import Comments from "@/components/projectDetails/comments/Comments";
import Orders from "@/components/projectDetails/tabs/Orders";
import AlertHelper from "@/helpsers/alert.helper";
import "@/css/admin-users.scss";
import { useShoppingListStore } from "@/stores/shoppingList.store";
import { useCurrencyStore } from "@/stores/currency.store";

export default {
    name: "ProjectDetails",
    components: {
        Orders,
        Comments,
        StyleQuiz,
        ShoppingList,
        TabsMenu,
        Proposal,
    },
    setup() {
        const auth = useAuthStore();
        const activeContentTab = ref('shoppingList'),
            alert = inject('alert'),
            isLoading = ref(false),
            projectInfo = ref(''),
            currentSlider = ref(0),
            activeTab = router.currentRoute.value.params?.activeTab;

        if ((router.currentRoute.value.params?.activeTab != 'order' && router.currentRoute.value.params?.nestedTab)
            || (router.currentRoute.value.params?.activeTab == 'order' && router.currentRoute.value.params?.nestedTab != 'details')
        ) {
            let urlName = 'project-details';
            if (auth.user.role == Role.Admin)
                urlName = 'admin.project-details';
            router.push({name: urlName, params: {
                id: router.currentRoute.value.params.id,
                activeTab: router.currentRoute.value.params.activeTab,
            }})
        }

        function changeTab(tabId) {
            if (auth.user.role == Role.Admin)
                router.push({name: 'admin.project-details', params: {'activeTab': tabId, 'id':  router.currentRoute.value.params?.id }})
            else
                router.push({name: 'project-details', params: {'activeTab': tabId, 'id':  router.currentRoute.value.params?.id }})
            activeContentTab.value = tabId;
        }

        activeContentTab.value = activeTab;


        async function fetchProjectInfo() {
            isLoading.value = true;
            axios.get(ApiHelper.getProjectDetailsUrl(router.currentRoute.value.params.id), {
                headers: authHelper.authHeader(),
            }).then(result => {
                projectInfo.value = result?.data ?? {};
                const meInProject = projectInfo.value.members.find(member => member.id === auth.user.id);
                projectInfo.value.myRoleInProject = meInProject?.projectRole ?? auth.user.role;
                if (projectInfo.value.designProposals.length == 0 && projectInfo.value.myRoleInProject === Role.Client)
                    activeContentTab.value = 'styleQuiz';
                isLoading.value = false;
            }).catch(errorResponse => {
                console.log("errorResponse");
                console.log(errorResponse);
                if(errorResponse?.response?.data?.code == '404')
                    router.push({ path: '/not-found' });
                else
                    AlertHelper.show(alert,'Błąd wczytywania strony',errorResponse.response?.data?.message,'error')
                isLoading.value = false;
            })
        }

        fetchProjectInfo();
        const emitter = inject('emitter');
        emitter.on('updateProjectDetails', () => {
            fetchProjectInfo()
        })
        /**
         * styleQuizResult is one new result per user
         * remove the previous user style
         * and append the new one
         */
        emitter.on('styleQuizCompleted', (styleQuizResult) => {
            fetchProjectInfo()
            if (projectInfo.value.styleQuizResults) {
                projectInfo.value.styleQuizResults = projectInfo.value.styleQuizResults
                .filter(result => result.user.id !== styleQuizResult.user.id)
                projectInfo.value.styleQuizResults.push(styleQuizResult);
            } else {
                projectInfo.value.styleQuizResults = [styleQuizResult];
            }
        })

        //Back to previous tab when click native back button on web browser.
        window.onpopstate = function() {
            activeContentTab.value = router.currentRoute.value.params?.activeTab
        };

        const shoppingListStore = useShoppingListStore()
        onMounted(() => {
            shoppingListStore.projectId = router.currentRoute.value.params?.id;
        })
        onBeforeUnmount(() => {
            shoppingListStore.projectId = null;
        })
        const currencyStore = useCurrencyStore();
        currencyStore.getCurrencies();

        const clients = computed(() => {
            const data =  projectInfo.value?.members?.filter(m => m.role === Role.Client) ?? [];
            // First client in array is the main client
            if (data.length > 0) {
                return [data[0]];
            }
            return data;
        })

        return {
            changeTab,
            activeContentTab,
            projectInfo,
            currentSlider,
            auth,
            Role,
            clients,
        };
    },
}
</script>

<style scoped lang="scss">
@use "@/css/proposals";

main.app-container {
    background-color: white;
}
.new-project {
    &__top {
        img {
            margin-right: 5px;
        }
        a {
            font: normal normal 500 1.75rem/1.2 Montserrat;
            color: #353535;
            background-color: transparent;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            &:hover {
                color: #9e5d57;
            }
        }
    }
}


</style>